import React, {Component} from 'react'
import {connect} from 'react-redux'
import McpIndexMenu from "./McpIndexMenu";
import McpIntegrations from "./McpIntegrations";
import SampleQuestionsAccordion from "../../SharedComponents/SampleQuestionsAccordian";
import BannerMessages from "../../App/API/BannerMessages";
import CopyURLSegment from "../../SharedComponents/CopyURLSegment";
import {getQueryParamValue} from "../../Constants/getQueryParamValue";
import {modifyMcpMenuItem} from "../../Actions/ModifyMcpMenuItem";
import AgentsIndex from "../Agents/AgentsIndex";

class McpAuthIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountMcpUrl: "",
            loading: false,
            error: null,
            sampleQuestions: [
                "What files do I have in my account?",
                "Which files are related to AB Company?",
                "For my PNL.xlsx spreadsheet, update profits for AB Company to 400",
                "Delete all rows where status equals expired",
                "Add a row for my data.xlsx spreadsheet with the following data. Name: AB Company, Profit: 400, Status: ongoing"
            ]
        };
    }

    componentDidMount(){
        const menuItem = getQueryParamValue("menuItem", window.location.href)

        if (menuItem !== ""){
            this.props.modifyMcpMenuItem(menuItem)
        } else {
            this.props.modifyMcpMenuItem('mcp')
        }

        this.fetchAccountKeys();
    }

    fetchAccountKeys = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            const userEmail = localStorage.getItem("email");
            if (!userEmail) {
                this.setState({ 
                    error: "User email not found. Please log in again.",
                    loading: false 
                });
                return;
            }

            const browserDomain = window.location.hostname;
            const apiRoot = browserDomain.includes("localhost") 
                ? "http://127.0.0.1:8080/" 
                : "https://api.apispreadsheets.com/";

            const response = await fetch(`${apiRoot}fetch-account-keys/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userEmail
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch account keys: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.status !== "success") {
                throw new Error("Failed to fetch account keys");
            }
            
            const accountMcpUrl = `https://mcp.apispreadsheets.com/account/${data.access_key}/${data.secret_key}`;
            
            this.setState({ 
                accountMcpUrl,
                loading: false 
            });

        } catch (error) {
            console.error('Error fetching account keys:', error);
            this.setState({ 
                error: error.message || "Failed to fetch account keys",
                loading: false 
            });
        }
    };

    getMcpURL = () => {
        if (this.state.loading) {
            return "Loading account MCP URL...";
        }
        
        if (this.state.error) {
            return `Error: ${this.state.error}`;
        }
        
        return this.state.accountMcpUrl || "MCP URL will be available shortly...";
    }

    renderContent = () => {
        if (this.props.mcpMenuItem === 'ai') {
            return (
                <AgentsIndex />
            );
        }

        // Default MCP content
        return (
            <div style={{ padding: "24px 48px" }}>
                <CopyURLSegment
                    url={this.getMcpURL()}
                    header={<span>MCP URL</span>}
                />
                
                <McpIntegrations />
                
                <SampleQuestionsAccordion 
                    open 
                    questions={this.state.sampleQuestions}
                />
            </div>
        );
    }

    render() {
        return (
            <div style={{minHeight: '100vh'}}>
                <div style={{display: "grid", gridTemplateColumns: "100px 1fr"}}>
                    <div>
                        <McpIndexMenu />
                    </div>
                    <div>
                        <BannerMessages/>
                        {this.renderContent()}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    fileInformation: state.mainState.fileInformation,
    filePK: state.mainState.filePK,
    sheetRead: state.mainState.sheetRead,
    mcpMenuItem: state.mainState.mcpMenuItem
})

const mapActionsToProps = {
    modifyMcpMenuItem: modifyMcpMenuItem
}

export default connect(mapStateToProps, mapActionsToProps)(McpAuthIndex)
